// extracted by mini-css-extract-plugin
export var circle = "_f5-1";
export var exitConfirmationModal = "_f5-5";
export var iframe = "_f5-0";
export var offline = "_f5-3";
export var online = "_f5-2";
export var workstationSelectError = "_f5-4";